import React from 'react';
import * as myPolicyConst from './privacyPolicyTexts';

class PrivacyPolicy extends React.Component {

  constructor(props) {
		super(props);
	}

	componentDidMount() {
		// document.body.classList.add('sidebar-hidden');
		// document.body.classList.remove('sidebar-mobile-show');
	}

	render() {
		return (
			<div className="app margin-bottom-100">

	      <div className="row">
	      <div className="col-12">
	      	{myPolicyConst.CST_POLICY_TEXT.map(this.showPolicyParagraph)}
				</div>
				</div>

			</div>
		)
	}

	showPolicyParagraph(parag, paragId) {
		return (
      <div key={'parag' + paragId}>
	      {(parag.type === 2) ? 
	      	<h3>{parag.text}</h3> : null}
	      {(parag.type === 1) ? 
	      	<h5>{parag.text}</h5> : null}
	      {(parag.type === 0) ? 
	      	<p>{parag.text}</p> : null}
	      {(parag.type === 3) ? 
	      	<li>{parag.text}</li> : null}
			</div>
		);
	}

}

export default PrivacyPolicy;